module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('transition-group', {
    attrs: {
      "enter-class": "hidden",
      "enter-to-class": "",
      "enter-active-class": "",
      "leave-class": "show",
      "leave-active-class": "",
      "leave-to-class": "hidden"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.is_visible),
      expression: "is_visible"
    }],
    key: "modal",
    class: ['modal', {
      fade: _vm.fade,
      show: _vm.is_visible
    }],
    attrs: {
      "id": _vm.id,
      "role": "dialog"
    },
    on: {
      "click": function($event) {
        _vm.onClickOut($event)
      },
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27)) { return null; }
        _vm.onEsc($event)
      }
    }
  }, [_c('div', {
    class: ['modal-dialog', 'modal-' + _vm.size]
  }, [_c('div', {
    ref: "content",
    staticClass: "modal-content",
    attrs: {
      "tabindex": "-1",
      "role": "document",
      "aria-labelledby": (_vm.hideHeader || !_vm.id) ? null : (_vm.id + '_modal_title'),
      "aria-describedby": _vm.id ? (_vm.id + '_modal_body') : null
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [(!_vm.hideHeader) ? _c('header', {
    ref: "header",
    staticClass: "modal-header"
  }, [_vm._t("modal-header", [_c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": _vm.id ? (_vm.id + '_modal_title') : null
    }
  }, [_vm._t("modal-title", [_vm._v(_vm._s(_vm.title))])], 2), _vm._v(" "), (!_vm.hideHeaderClose) ? _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": _vm.closeTitle
    },
    on: {
      "click": _vm.hide
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]) : _vm._e()])], 2) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "body",
    staticClass: "modal-body",
    attrs: {
      "id": _vm.id ? (_vm.id + '_modal_body') : null
    }
  }, [_vm._t("default")], 2), _vm._v(" "), (!_vm.hideFooter) ? _c('footer', {
    ref: "footer",
    staticClass: "modal-footer"
  }, [_vm._t("modal-footer", [_c('b-btn', {
    attrs: {
      "variant": "secondary"
    },
    on: {
      "click": function($event) {
        _vm.hide(false)
      }
    }
  }, [_vm._v(_vm._s(_vm.closeTitle))]), _vm._v(" "), (_vm.ok2Title !== '') ? _c('b-btn', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        _vm.ok2Pressed()
      }
    }
  }, [_vm._v(_vm._s(_vm.ok2Title))]) : _vm._e(), _vm._v(" "), _c('b-btn', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        _vm.hide(true)
      }
    }
  }, [_vm._v(_vm._s(_vm.okTitle))])])], 2) : _vm._e()])])]), _vm._v(" "), (_vm.is_visible) ? _c('div', {
    key: "modal-backdrop",
    class: ['modal-backdrop', {
      fade: _vm.fade,
      show: _vm.is_visible
    }]
  }) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fa83e344"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/bootstrap-vue/components/modal.vue
// module id = 266
// module chunks = 0